// extracted by mini-css-extract-plugin
export default {"inputContainer":"MalfunctionList_inputContainer__CDk8I","dropdown":"MalfunctionList_dropdown__-Ob8s"};